import React from 'react';
import i18n from 'I18n';
import { noWebapp, onlyHaveWebapp } from 'config/CustomEnums';
import './ThisCampaignDeeplink.scss';

const ThisCampaignDeeplink = ({
  onThisCampaignSelected
}) => {

  return (
    <>
      {!noWebapp && (
        <div
          className='this-campaign-deeplink-button'
          onClick={() => {
            onThisCampaignSelected("{{This campaign URL for web}}")
          }}>
          <span>{i18n.t('message_insert_this_campaign_web')}</span>
        </div>
      )}
      {
        !onlyHaveWebapp && (
          <div
            className='this-campaign-deeplink-button'
            onClick={() => {
              onThisCampaignSelected("{{This campaign deep link for app}}")
            }}>
            <span>{i18n.t('message_insert_this_campaign_app')}</span>
          </div>
        )}
    </>
  );
}

export default ThisCampaignDeeplink;
